import { convertWidth } from './convertWidth';
export function convertWidthToHz(peaks, frequency) {
    return convertWidth(peaks, { frequency, convertTo: 'hz' });
}
//# sourceMappingURL=convertWidthToHz.js.map